module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-item",
    style: ('margin-top: ' + _vm.contentMarginTop + 'px')
  }, [_c('div', {
    staticClass: "edge-line"
  }), _vm._v(" "), _c('div', {
    staticClass: "wrapper",
    class: _vm.noPadding ? 'no-padding' : ''
  }, [(_vm.title) ? _c('div', {
    staticClass: "header"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n                " + _vm._s(_vm.title) + "\n            ")]), _vm._v(" "), _vm._m(0)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_vm._t("default")], 2)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "line-arrow"
  }, [_c('div', {
    staticClass: "line"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-23a5876e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/partial/ContentItem.vue
// module id = 15
// module chunks = 1 2 3 5 6 7